/**
 * The reviews.io store identifier. Shared by the rating-snippet widget, the
 * client-side rating API, the `ReviewsIoProvider`, and the Centra reviews.io
 * feed redirect. Kept in a client-safe module (no `server-only`) so both client
 * and server code can import it.
 */
export const REVIEWS_STORE_ID = "itskaos.com";
